import styled from "styled-components";

import Spring from "../../components/Spring";

export const StyledTranslations = styled(Spring)`
    background-color: ${p => p.theme.c.snow};
    padding: 50px 20px 20px;
    position: relative;
    line-height: 28px;
    min-height: calc(100vh - 50px);
`;
